<template>
  <v-card class="logo my-5">
    <img src="@/assets/icon.png" alt="SCC365 Logo">
  </v-card>
</template>

<script>
export default {
  name: 'Logo'
}
</script>

<style scoped>
.logo { margin: 0 auto; width: 100%; max-width: 5em; }
.logo img { width: 100%; height: 100%; }
</style>
